import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--products--commissions--policies--dashboard`
  }

  doPoliciesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-8 pr-1" data-${this.controllerName}-target="list" data-controller="financials--products--commissions--policies--index"></div>
                  <div class="col-4 pl-1" data-${this.controllerName}-target="view" data-controller="financials--products--commissions--policies--save financials--products--commissions--policies--show"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--regularizations--show--main").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--products--purchases--dashboard--main").contentTarget.innerHTML = html)
    }).then(() => {

      controller.getControllerByIdentifier(`financials--products--commissions--policies--index`).permission = `financial_commission_policies`
      controller.getControllerByIdentifier(`financials--products--commissions--policies--save`).permission = `financial_commission_policies`
      controller.getControllerByIdentifier(`financials--products--commissions--policies--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`financials--products--commissions--policies--save`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
